import React from 'react';
import aboutImg from '../../images/profile1.jpg'
import './About.css'
import Type from './Type';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faDownload } from "@fortawesome/free-solid-svg-icons";
const About = () => {
    return (
        <div className="container">
            <div className="row flex-column-reverse flex-lg-row">
                <div className="d-flex align-items-center justify-content-center col-sm-12 col-md-6 mt-5 text-center">
                    <div>
                        <h1>Hello!</h1>
                        <h2>I'm Habibullah Md.Asif</h2>
                        <h2 className="type"><Type /></h2>
                        <Link to="/aboutDetail" className="btn btn-dark m-3">About Me</Link>
                        <a
                            href="https://drive.google.com/uc?export=download&id=1fkdVKep7A3FyYddBstHmC3VjKIUxuoMf" target="_blank"
                            className="btn btn-dark"><FontAwesomeIcon icon={faDownload} /> Download Resume</a>
                    </div>
                </div>
                <div className="col-sm-12 col-md-6 mt-5">
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={aboutImg} class="img-fluid img-responsive w-75" alt="Responsive image" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;

